import styled from 'styled-components';
import color from '../../../constants/color';
import MaterialUi from '../../../material-UI';

export const MenuItem = styled(MaterialUi.MenuItem)`
  color: ${color.grey9};
`;
export const Input = styled(MaterialUi.TextField)``;
